'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

exports.default = StepTwo;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _uploadFileButton = require('./uploadFileButton');

var _uploadFileButton2 = _interopRequireDefault(_uploadFileButton);

var _preview = require('./preview');

var _preview2 = _interopRequireDefault(_preview);

require('./styles.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function preventDefault(event) {
  event.stopPropagation();
  event.preventDefault();
}

function StepTwo(props) {
  var onProcessFile = props.onProcessFile,
      isLoading = props.isLoading,
      hasFileSelected = props.hasFileSelected,
      columns = props.columns,
      data = props.data,
      onRemoveFile = props.onRemoveFile,
      fileName = props.fileName,
      fileType = props.fileType;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDragOver = _useState2[0],
      setIsDragOver = _useState2[1];

  var getContainerClassNames = function getContainerClassNames() {
    return (0, _classnames2.default)('rainbow-import-records-flow_step-two-container', {
      'rainbow-import-records-flow_step-two-container-drag-over': isDragOver
    });
  };

  var handleChange = function handleChange(event) {
    onProcessFile(event.target.files[0]);
  };

  var handleDragLeave = function handleDragLeave() {
    setIsDragOver(false);
  };

  var handleDragOver = function handleDragOver(event) {
    preventDefault(event);
    setIsDragOver(true);
  };

  var handleDrop = function handleDrop(event) {
    preventDefault(event);
    setIsDragOver(false);
    var files = event.dataTransfer.files;

    if (files.length === 1 && files[0].type === 'text/csv') {
      onProcessFile(files[0]);
    }
  };

  if (hasFileSelected) {
    return _react2.default.createElement(_preview2.default, {
      fileName: fileName,
      fileType: fileType,
      columns: columns,
      data: data,
      isLoading: isLoading,
      onRemoveFile: onRemoveFile
    });
  }

  return _react2.default.createElement('div', {
    className: getContainerClassNames(),
    onDragEnter: preventDefault,
    onDragLeave: handleDragLeave,
    onDragOver: handleDragOver,
    onDrop: handleDrop,
    draggable: true
  }, _react2.default.createElement(_uploadFileButton2.default, {
    onChange: handleChange
  }), _react2.default.createElement('h1', {
    className: 'rainbow-import-records-flow_step-two-text'
  }, 'Find the file in your desktop.'));
}

StepTwo.propTypes = {
  onProcessFile: _propTypes2.default.func,
  isLoading: _propTypes2.default.bool,
  hasFileSelected: _propTypes2.default.bool,
  columns: _propTypes2.default.array,
  data: _propTypes2.default.array,
  onRemoveFile: _propTypes2.default.func,
  fileName: _propTypes2.default.string,
  fileType: _propTypes2.default.string
};
StepTwo.defaultProps = {
  onProcessFile: function onProcessFile() {},
  isLoading: false,
  hasFileSelected: false,
  columns: [],
  data: [],
  onRemoveFile: function onRemoveFile() {},
  fileName: '',
  fileType: ''
};